
import { FETCH_RESULT } from '../actions/types'


const resultReducer = (state = [], action) => {
    switch (action.type) {
    case FETCH_RESULT:
     return action.results

      default:
      return state
  }
}

export default resultReducer